<template>
    <div class="card border-light borda-redonda sombra">
        <div class="card-body">
            <h6 class="card-title text-center">
                Compartilhe as fotos do atendimento
            </h6>
            <div class="card-text">
                <div class="col-12 mb-3 lh-18">
                    <small class="text-justify">
                        Para segurança do atendimento e do veículo nos envie as fotos de antes e depois da chegada do prestador.
                    </small>
                </div>
                <div class="col-12 text-right">
                    <input type="file" ref="files" hidden multiple accept="image/*;capture=camera" @change="adicionarArquivo()">
                    <button type="button"
                        class="btn btn-warning text-white"
                        @click="escolherAnexo()"
                        :disabled="loading"
                    >
                        {{ loading ? `Aguarde ...` : `Enviar` }} <i class="fa fa-camera"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";


export default {
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapState('Atendimento', {
            idAtendimentoUrl: 'idAtendimentoUrl'
        })
    },
    methods: {
        adicionarArquivo() {
            const files =  this.$refs.files.files;
            if (files.length == 0) {
                return;
            }

            this.loading = true;
            let formData = new FormData();
            for( let i = 0; i < files.length; i++ ){
                let file = files[i];
                formData.append('files[' + i + ']', file);
            }
            
            this.$http.post(`${process.env.VUE_APP_URL_API}/client/atendimento/${this.idAtendimentoUrl}/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.loading = false;
                this.$bvModal.msgBoxOk(response.data.mensagem, {centered: true});
            }).catch((error) => {
                this.loading = false;
                this.$bvModal.msgBoxOk(error.response.status < 500 ? error.response.data.mensagem : 'Erro ao enviar os anexos', {centered: true});
            });
        },
        escolherAnexo() {
            this.$refs.files.value = "";
            this.$refs.files.click();
        },
    },
}
</script>

